import { render } from "./follow_card.vue?vue&type=template&id=0e018ede"
import script from "./follow_card.js?vue&type=script&lang=js"
export * from "./follow_card.js?vue&type=script&lang=js"

import "./follow_card.vue?vue&type=style&index=0&id=0e018ede&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__